/*
 * ParseGround
 * All rights reserved.
 */

import SashiDo from 'lib/SashiDo';

import Icon                       from 'components/Icon/Icon.react';
import Button                     from 'components/Button/Button.react';
import AppsManager                from 'lib/AppsManager';
import React                      from 'react';
import PropTypes                  from 'prop-types';
import ParseApp                   from 'lib/ParseApp';
import history from 'dashboard/history';
import styles                     from './CloudCodeStatus.scss';

export default class CloudCodeStatus extends React.Component {
  constructor() {
    super();

    this.state = {
      showRefresh: false,
    }
  }

  componentWillUnmount() {
    if(this._server_check_interval){ clearInterval(this._server_check_interval) }
  }

  componentDidMount() {
    this.hasServerInfo = this.context.currentApp.serverInfo && Object.keys(this.context.currentApp.serverInfo).length !== 0;
    this.startServerChekcInterval();
  }

  componentWillUpdate() {
    if(this._server_check_interval){
      clearInterval(this._server_check_interval)
      this.startServerChekcInterval();
    };
  }

  shouldComponentUpdate({nextState}) {
    if (!nextState && this.state === nextState) {
      return false;
    }
    return true;
  }

  check() {
    const region = this.context.currentApp.region;
    const serviceName = this.context.currentApp.serviceName;

    return SashiDo.serverStatusCheck({region, serviceName}).then(({server}) => {
      if(server) {
        let states = { server_status: server.state ? server.state : null};

        if(server.state != 'ready') {
          states.showRefresh = true;
        }

        this.setState(states);
      }
    });
  }

  handleManageOnRefresh() {
    window.location.reload()
  }

  startServerChekcInterval() {
    this._server_check_interval = setInterval(() => this.check(), 5000);
  }

  navigateToLogs(type, e) {
    const { appId } = this.props;
    history.push(`/products/apps/${appId}/runtime/${type}`)
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    const { appId } = this.props;
    const server_status = this.state.server_status;

    let message = null;
    if(server_status == 'building') {
      message = <span className={styles.loader}>
        <span className={styles.loaderDots}></span>Your Cloud Code is Building now.
        <a
          href={`/products/apps/${appId}/runtime/builds`}
          onClick={this.navigateToLogs.bind(this, 'builds')}>
          View Logs.
        </a>
      </span>
    }

    if(server_status == 'deploying') {
      message = <span className={styles.loader}>
        <span className={styles.loaderDots}></span>Your Cloud Code is Deploying.
        <a
          href={`/products/apps/${appId}/runtime/deployments`}
          onClick={this.navigateToLogs.bind(this, 'deployments')}>
          View Logs.
        </a>
      </span>
    }

    if(server_status == 'ready' && this.state.showRefresh) {
      if(this.props.activateView) {
        window.location.reload();
      }
      message = <span>Your Cloud Code is Ready to use.</span>
    }

    return (
      <div className={styles.status}>
        <div></div>
        <div className={styles.message}>
          <div className={this.state.server_status == 'ready' ? styles.green : null}>
            {message}
          </div>
        </div>
        {
          this.state.showRefresh && this.state.server_status == 'ready'
            ? <Button color='green' value='Refresh' onClick={this.handleManageOnRefresh.bind(this)} />
            : null
        }
      </div>
    );
  }
}

CloudCodeStatus.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp)
};

